
<template>
  <div class="confirm-wrapper" v-show="display">
    <div class="modal" @click="handleAction('confirm')" @touchmove.prevent></div>
    <transition name="confirm-bounce" @after-leave="afterLeave">
      <div class="confirm-box" v-show="visible">
        <p class="confirm-header" v-if="title">{{ title }}</p>
        <p class="confirm-body" v-if="message">{{ message }}</p>
        <div class="confirm-footer">
          <button class="cancel-btn" @click="handleAction('cancel')" v-if="showCancelBtn">
            {{ cancelBtnText}}
          </button>
          <button class="confirm-btn" @click="handleAction('confirm')" v-if="showConfirmButton">
            {{ confirmBtnText }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "confirm",
  data() {
    return {
      display: false,
      visible: false
    };
  },
  methods: {
    afterLeave() {
      this.display = false;
    },
    handleAction(action) {
      if (action === "cancel" || action === "confirm") {
        this.callBack && this.callBack(action);
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    message: String,
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default: "确定"
    },
    cancelBtnText: {
      type: String,
      default: "取消"
    },
    callBack: Function
  }
};
</script>
<style lang="less" scoped>
.confirm-wrapper {
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
}
.confirm-box {
  position: absolute;
  top: 30%;
  left: 50%;
  width: 5.75rem;
  min-height: 2rem;
  padding: 0.6rem 0.3rem 0.5rem;
  transform: translate(-50%);
  background-color: #fff;
  font-size: 0.32rem;
  text-align: center;
  letter-spacing: 2px;
  border-radius: 5px;
  .confirm-header {
    font-size: 18px;
    padding: 18px 0 14px;
    text-align: center;
    color: #333333;
  }
  .confirm-body {
    padding-bottom: 0.7rem;
  }
  .confirm-footer {
    display: flex;
    text-align: center;
    line-height: 44px;
    justify-content: space-around;
    button {
      width: 2.1rem;
      height: 0.8rem;
      text-align: center;
      border: 1px solid #999;
      border-radius: 5px;
      font-size: 0.3rem;
      letter-spacing: 2px;
      line-height: .8rem;
      &.confirm-btn {
        color: #e50011;
        border: 1px solid #e50011;
      }
    }
  }
}
// 添加动画效果
.confirm-bounce-enter-active,
.confirm-bounce-leave-active {
  transition: all 0.3s ease;
}
.confirm-bounce-enter {
  opacity: 0;
  // transform: scale(0.5);
}
.confirm-bounce-leave-active {
  opacity: 0;
  // transform: scale(0.8);
}
</style>


// WEBPACK FOOTER //
// src/components/confirm/confirm.vue